import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { Modal, Form, Descriptions, InputNumber, DatePicker, Typography, notification } from 'antd';
import axiosInstance from 'utilities/axios';

const { Title, Text } = Typography;

const MSRPModal = ({ visible, onClose, onChange, currentMSRP, futureMSRP, style }) => {
  const [form] = Form.useForm();
  const startDate = Form.useWatch('startDate', form);

  useEffect(() => {
    if (futureMSRP) {
      form.setFieldsValue({
        msrp: futureMSRP.msrp,
        startDate: futureMSRP.startDate ? dayjs(futureMSRP.startDate) : null,
        endDate: futureMSRP.endDate ? dayjs(futureMSRP.endDate) : null,
      });
    } else {
      form.resetFields();
    }
  }, [futureMSRP]);

  const handleSubmit = (values) => {
    axiosInstance
      .post(`/products/styles/${style}/msrp`, {
        msrp: values.msrp,
        startDate: values.startDate.format('YYYY-MM-DD'),
        endDate: values.endDate ? values.endDate.format('YYYY-MM-DD') : null,
      })
      .then(() => {
        onChange();
        onClose();
      })
      .catch((error) => {
        notification.error({
          message: 'Error',
          description: error.response?.data?.message || 'Failed to update MSRP',
        });
      });
  };

  const handleClose = () => {
    if (futureMSRP) {
      form.setFieldsValue({
        msrp: futureMSRP.msrp,
        startDate: futureMSRP.startDate ? dayjs(futureMSRP.startDate) : null,
        endDate: futureMSRP.endDate ? dayjs(futureMSRP.endDate) : null,
      });
    } else {
      form.resetFields();
    }
    onClose();
  };

  return (
    <Modal
      title="MSRP"
      open={visible}
      onCancel={handleClose}
      zIndex={2000}
      onOk={() => form.submit()}
      okText="Save"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          label="Future MSRP"
          name='msrp'
          rules={[{ required: true, message: 'Please enter the future MSRP' }]}
        >
          <InputNumber
            style={{ width: '100%' }}
            min={0}
            step={0.01}
            prefix="$"
            placeholder="Enter future MSRP"
          />
        </Form.Item>
        <Form.Item
          label="Effective Date"
          name='startDate'
          rules={[{ required: true, message: 'Please select the effective date' }]}
        >
          <DatePicker
            style={{ width: '100%' }}
            disabledDate={(current) => current && current < dayjs().startOf('day')}
          />
        </Form.Item>
        <Form.Item
          label="End Date"
          name='endDate'
        >
          <DatePicker
            style={{ width: '100%' }}
            disabledDate={(current) => {
              if (startDate) {
                return current && (current < dayjs(startDate).startOf('day'));
              }
              return current && current < dayjs().startOf('day');
            }}
          />
        </Form.Item>
      </Form>
      <Title level={5}>Current MSRP</Title>
      {currentMSRP ? (
        <Descriptions
          column={1}
          bordered
          style={{ marginBottom: 24 }}
        >
          <Descriptions.Item label="Current MSRP">
            ${currentMSRP?.msrp.toFixed(2)}
          </Descriptions.Item>
          <Descriptions.Item label="Effective Date">
            {dayjs(currentMSRP?.startDate).format('MM/DD/YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label="End Date">
            {currentMSRP?.endDate ? dayjs(currentMSRP.endDate).format('MM/DD/YYYY') : 'No End Date'}
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <Text>No current MSRP available.</Text>
      )}
      
    </Modal>
  )
};

export default MSRPModal;